module.exports = __webpack_public_path__ + "img/404-1.88b6719f.svg";